const styles = {
  selectedMenuItem: {
    backgroundColor: (theme) => theme.palette.primary.main,
  },
}

export default styles
